/*
 * @Author: hejianbo
 * @Date: 2022-03-14 09:48:15
 * @FilePath: \MCN_new\app\main\submissionManage\personalLibrary\editPic\editPicRouter.js
 * @Description: 
 */
/**
 * 编辑页路由
 */
"use strict";
angular.module("editPicRouterModule", []).
config(["$stateProvider", function($stateProvider) {
    $stateProvider.state("editPic", {
        url: "/editPic?id&type",
        views: {
            "": {
                template: '<div class="view_head" ui-view="header"></div>' +
	                      '<div class="view_body">' +
	                      '<div class="" ui-view="main"></div>' +
	                      '</div>'
            },
            "header@editPic": {
                templateUrl: 'header/headerDetails_tpl.html',
                controller: 'webHeaderCtrl'
            },
            "main@editPic": {
                templateUrl: "./main/submissionManage/personalLibrary/editPic/editPic_tpl.html",
                controller: "editPicCtrl"
            }
        }
    }).state("editPicdetail", {
        url: "/editPicDetail?articleId&type",
        views: {
            "": {
                template: '<div class="view_head" ui-view="header"></div>' +
	                      '<div class="view_body">' +
	                      '<div class="" ui-view="main"></div>' +
	                      '</div>'
            },
            "header@editPicdetail": {
                templateUrl: 'header/headerDetails_tpl.html',
                controller: 'webHeaderCtrl'
            },
            "main@editPicdetail": {
                templateUrl: "./main/submissionManage/personalLibrary/atlas/atlasDetail/atlasDetail_tpl.html",
                controller: "editPicDetailCtrl"
            }
        }
    });
}]);